import axios from "axios";
import config from "./config";

const getSignedURL = async (key) => {
  const args = {
    Key: key,
  };

  const [url, params] = await config("getSignedUrl", args);

  return await axios.post(url, params).then((res) => res.data);
};

export default getSignedURL;
